import { SET_VALUATION } from './actionTypes'
import { ValuationActionTypes } from './types'

const initialState = {
	conditionAnswers: [],
	redbookCode: "",
	kms: 0,
	kmUsed: 0,
	valuation: 0,
	pricingMatchInfo: "", 
}

export default (state = initialState, action: ValuationActionTypes) => {
  switch (action.type) {
    case SET_VALUATION:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
